import staticImageLoader from "@lib/staticImageLoader";
import { Box, Grid, Link as MuiLink, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Pagination from "components/pagination";
import Image from "next/image";
import Link from "next/link";
import FindTemplateImage from "public/image/landing_page/category/find_template.svg";
import * as React from "react";
import ProductCard from "../productCard";

type Props = {
  path: string;
  templates: any[];
  pagination: any;
};

export const Container = styled("div")<{ size?: "lg" | "xl" }>(
  ({ theme, size = "lg" }) => ({
    maxWidth:
      size === "lg" ? theme.breakpoints.values.lg : theme.breakpoints.values.xl,
    marginLeft: "auto",
    marginRight: "auto",
    // paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  })
);

export default function List({
  path,
  templates,
  pagination,
}: Props): React.ReactElement {
  if (templates.length <= 0) {
    return (
      <Box
        sx={{
          px: {
            xs: 0,
            sm: 2,
          },
          // border: "1px solid",
          borderRadius: 1,
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          // bgcolor: "#fff9c4",
          // borderColor: "#ffc107",
        }}
      >
        <Box sx={{ maxWidth: 650, mx: "auto" }}>
          <Image
            src={FindTemplateImage}
            width={650}
            height={650}
            loader={staticImageLoader}
          />
        </Box>
        <Typography variant="h4" align="center">
          Sorry, couldn't find any products.
        </Typography>
        {pagination.current_page > 1 && (
          <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
            <Pagination
              pagination={pagination}
              hrefPrefix={`${process.env.NEXT_PUBLIC_CLIENT_SERVER}${path}`}
            />
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box>
      <Grid container spacing={3}>
        {templates.map((template) => {
          return (
            <Grid key={template.id} item xs={12} sm={12} md={6} lg={4} xl={4}>
              <Link href={`/design/${template.slug}`} passHref>
                <MuiLink underline="none" color="inherit">
                  <ProductCard template={template} />
                </MuiLink>
              </Link>
            </Grid>
          );
        })}
      </Grid>
      <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
        <Pagination
          pagination={pagination}
          hrefPrefix={`${process.env.NEXT_PUBLIC_CLIENT_SERVER}${path}`}
        />
      </Box>
    </Box>
  );
}
